export default "__VITE_ASSET__Dt3Seq0A__"